<template>
  <section>
    <!-- Componentes externos -->
    <h3 class="primary--text">
      <v-icon color="primary">business</v-icon> Lista de servidores públicos -
      Vacaciones
    </h3>
    <v-layout row wrap align-center>
      <!-- Boton filtro -->
      <v-flex shrink>
        <v-tooltip bottom>
          <v-btn
            @click.native="
              () => {
                filterShow = filterShow ? false : true;
              }
            "
            class="btn-refresh"
            slot="activator"
            ><v-icon>filter_list</v-icon>
          </v-btn>
          <span>Búsqueda/filtros</span>
        </v-tooltip>
        <!-- Boton acutualizar -->
        <v-tooltip bottom>
          <v-btn
            @click.native="cargarDatos()"
            class="btn-refresh"
            slot="activator"
            ><v-icon>refresh</v-icon>
          </v-btn>
          <span>{{ $t("common.updateList") }}</span>
        </v-tooltip>
      </v-flex>
      <v-flex shrink>
        <NotificacionPapeletasNoPresentadas />
      </v-flex>
    </v-layout>
    <!-- Filtros-->
    <v-flex xs12>
      <transition name="slide-fade">
        <div class="filter-container-rrhh" v-show="filterShow">
          <v-icon small color="primary">search</v-icon>
          <div class="filter-item">
            <v-text-field
              label="Nombre"
              type="text"
              v-model="form.nombre"
              @input="filternombre"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha de ingreso"
              type="date"
              v-model="form.fecha_ingreso"
              @input="filterFechaIngreso"
            ></v-text-field>
          </div>

          <div class="filter-item">
            <v-text-field
              label="Item"
              type="number"
              v-model="form.item"
              @input="filterItem"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Estado"
              type="text"
              v-model="form.activo_pasivo"
              @input="filterActivoPasivo"
            ></v-text-field>
          </div>
          <!-- botones cerrar -->
          <div class="btn-filter">
            <v-tooltip bottom>
              <v-btn icon small slot="activator" @click.native="recargar()">
                <v-icon small>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                  }
                "
              >
                <v-icon small>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip>
          </div>
        </div>
      </transition>
    </v-flex>
    <v-card>
      <v-card-text>
        <v-data-table
          :items="lista_funcionarios"
          :headers="headers"
          class="elevation-1"
          :disable-initial-sort="true"
          item-key="id"
          :search="filters"
          :custom-filter="customFilter"
          :loading="loading"
          no-data-text="No se tiene registros"
          no-results-text="No se encontraron coincidencias"
          :rows-per-page-items="[25, 50, { text: 'Todos', value: -1 }]"
        >
          <!-- Template de filas y columnas  -->
          <template slot="items" slot-scope="items">
            <td class="text-xs-center">{{ items.item.nombre }}</td>
            <td class="text-xs-center">{{ items.item.fecha_ingreso }}</td>

            <td class="text-xs-center">{{ items.item.item }}</td>

            <td class="text-xs-center">
              <v-chip
                :color="
                  items.item.activo_pasivo.split('|')[1] == 'Activo'
                    ? 'success'
                    : 'error'
                "
                text-color="white"
                >{{
                  items.item.activo_pasivo.split("|")[1] == "Activo"
                    ? "Activo"
                    : "Pasivo"
                }}</v-chip
              >
            </td>
            <td class="text-xs-center">
              <v-btn
                color="success"
                title="Aprobar"
                :to="`/vacaciones-programadas-rrhh/${items.item.id_persona}`"
              >
                Ver Vacaciones programadas
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
import NotificacionPapeletasNoPresentadas from "./components/NotificacionPapeletasNoPresentadas.vue";
import Filtros from "./mixins/filtrosPersonas.js";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [Filtros],
  // Definición de componentes importados
  components: {
    NotificacionPapeletasNoPresentadas
  },
  // Variables iniciales del componente
  data() {
    return {
      lista_funcionarios: [],
      // Cabecera de la tabla
      headers: [
        // { text: "Número de documento", value: "nro_doc", align: "center" },
        { text: "Nombres", value: "nombre", align: "center" },
        {
          text: "Fecha de incorporación",
          value: "fecha_ingreso",
          align: "center"
        },

        { text: "Ítem", value: "item", align: "center" },
        { text: "Estado", value: "activo_pasivo", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      respuestaFuncion: ["usuario", "correo", "contraseña"],
      dialog: false,
      loading: false,
      // Variables filtros
      filterShow: true,
      form: {
        activo_pasivo: "Activo"
      },
      filters: {
        nombre: "",
        fecha_ingreso: "",
        fecha_pasivo: "",
        item: "",
        activo_pasivo: "Activo"
      }
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [76, 32]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/accion-no-permitida");
    }
    await this.cargarDatos();
    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.$bus.$on("closeDialogCreado", item => {
      this.respuestaFuncion = item.split("-");
      this.dialog = true;
    });
  },
  // Métodos y funciones del componente
  methods: {
    async cargarDatos() {
      this.loading = true;
      try {
        let rpta = await this.$service.graphql({
          query: `
              query{
                vListaPersonals(id_estado:1,l_tipo_persona:[1]){
                  rows{
                    id_persona
                    id_estado
                    nro_doc
                    nro_complemento
                    item
                    nombre
                    unidad
                    fecha_ingreso
                    cargo
                    id_cargo
                    id_puesto
                    id_item
                    id_unidad
                    id_movilidad
                    estado
                    fecha_pasivo
                    activo_pasivo
                  }
                }
              }
            `
        });
        rpta = rpta.vListaPersonals.rows;
        this.lista_funcionarios = rpta;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    movilidad(item) {
      this.$bus.$emit("openDialogMovilidad", item);
    },
    editarPersona(item) {
      this.$bus.$emit("openDialogEditarPersona", item);
    },
    aprobarMovilidad(item) {
      this.$bus.$emit("openDialogAprobarMovilidad", item);
    },
    crearPersona() {
      this.$bus.$emit("openDialogCrearPersona");
    },
    close() {
      this.respuestaFuncion = [];
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/ListadoPersonasVacacionesRRHH.vue